module.exports = __webpack_public_path__ + "img/designSprints.0808d361.png";